import _ from "lodash";

export const updateSelected = (state, action) => {
  return {
    ...state,
    selected: action.selected,
    showDropdown: false
  };
};

export const updateInitialClick = (state, action) => {
  return {
    ...state,
    initialClick: action.value
  };
};

export const updateSelectedTrucklistNames = (state, action) => {
  return {
    ...state,
    selectedTrucksNames: action.selectedTrucksNames,
  };
};

export const updateCampaignVehiclesMapBox = (state, action) => {
  return {
    ...state,
    campaignVehicles: Object.keys(action.vehicles).map(key => {
      return action.vehicles[key];
  })
  };
};

export const resetCampaignVehiclesMapBox = (state, action) => {
  return {
    ...state,
    campaignVehicles: {}
  };
};


export const updateProfile = (state, action) => {
  return {
    ...state,
    userProfileUrl: action.userProfileUrl,
  };
};


export const updateStartDate = (state, action) => {
  return {
    ...state,
    startDate: action.startDate,
    timePeriod: action.index
  };
};

export const updateAnalytics = (state, action) => {
  return {
    ...state,
    analytics: {
      ...state.analytics,
      vehicleCount: Math.round(action.vehicleCount),
      totalMilesDriven: Math.round(action.miles),
      totalImpressions: Math.round(action.impressions)
    }
  };
};

export const toggleDropdown = (state, action) => {
  return {
    ...state,
    showDropdown: !state.showDropdown
  };
};

export const loadClientCampaigns = (state, action) => {
  return {
    ...state,
    campaigns: action.campaigns,
    campaignAnalytics: action.campaigns,
    selected: action.selected
  };
};

export const setBoxiMap = (state, action) => {
  return {
    ...state,
    map: action.map
  };
};

export const updateCampaignVehicles = (state, action) => {
  let campaigns = _.cloneDeep(state.campaigns);
  campaigns[action.id].vehicles = action.vehicles;
  return {
    ...state,
    campaigns: campaigns,
    updateCampaign: !state.updateCampaign
  };
};

export const updateCampaignVehiclesTemp = (state, action) => {
  let campaigns = _.cloneDeep(state.campaigns);
  campaigns[action.id].vehicles = action.vehicles;
  campaigns[action.id].analytics = action.analytics;
  return {
    ...state,
    campaigns: campaigns,
    updateCampaign: !state.updateCampaign
  };
};